<template>
  <div class="homeContainer">
    <head-top></head-top>
    <div class="noticeDiv contentWidth">
      <p class="title">平台公告</p>
      <div class="content">
        <p class="noticeTitle">{{info.title}}</p>
        <p v-html="info.content"></p>
      </div>
    </div>
    <foot-btm></foot-btm>
  </div>
</template>

<script>
import headTop from '@/components/layout/headTop'
import footBtm from '@/components/layout/footBtm'
const Mock = require('mockjs')
export default {
  name: 'noticeDetails',
  components: {
    headTop,
    footBtm
  },
  data () {
    return {
      info: {
        title: '',
        time: '',
        content: ''
      }
    }
  },
  mounted () {
    if (this.$route.query.index !== undefined) {
      this.info = Mock.mock(require('@/mock/json/notice')).noticeList[this.$route.query.index]
      this.info.content = this.info.content.replace(/\n/g, '<br>')
    } else {
      this.$message({
        type: 'warning',
        message: '服务器走丢了...'
      })
      console.log('index参数缺失')
    }
  }
}
</script>

<style scoped lang="less">
.homeContainer{
  background: #f7f8fb;
  height: 100%;
  overflow: auto;
  .noticeDiv {
    background: #fff;
    margin-top: 41px;
    padding-bottom: 40px;
    .title {
      width: 100%;
      height: 60px;
      line-height: 60px;
      background: #E8EBF3;
      font-size: 18px;
      padding-left: 41px;
      box-sizing: border-box;
    }
    .content{
      padding: 90px;
      .noticeTitle{
        font-size: 19px;
        font-weight: bold;
        margin-bottom: 40px;
        text-align: center;
      }
    }
  }
  .tips{
    width: 100%;
    font-size: 14px;
    color: #999;
    margin: 40px 0;
    text-align: center;
  }
}
</style>
